// wedora/frontend/src/components/LoadingScreen/LoadingScreen.js
import React from 'react';
import { Box } from '@mui/material';
import { keyframes, useTheme } from '@mui/material/styles';

const breathing = keyframes`
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.15);
    opacity: 0.75;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const LoadingScreen = ({ isLoaded = false }) => {
  const theme = useTheme();
  
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: theme.palette.primary.dark, // MÓDOSÍTVA: primary.dark háttér
        zIndex: 9999,
        animation: isLoaded ? `${fadeOut} 0.5s ease-out forwards` : 'none',
        pointerEvents: isLoaded ? 'none' : 'auto',
      }}
    >
      {/* Logo breathing animációval */}
      <Box
        component="img"
        src="/logo.png" // VAGY logo.svg
        alt="Wedigo Logo"
        sx={{
          width: { xs: 150, sm: 200, md: 250 },
          animation: `${breathing} 3s ease-in-out infinite`,
          filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))', // MÓDOSÍTVA: Erősebb árnyék a sötét háttérhez
        }}
      />
      {/* ELTÁVOLÍTVA: Töltés szöveg */}
    </Box>
  );
};

export default LoadingScreen;